import { Tab, Tabs } from '@mui/material';
import { AppTab } from 'data/interfaces';
import { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom"


interface TabBarProps {
  tabs: AppTab[]
};

export default function TabBar({tabs} : TabBarProps) {
  const [tab, setTab] = useState(0);
  let location = useLocation();

  useEffect(() => {
    setTab(tabs.findIndex(tab => tab.path.toLocaleLowerCase() === location.pathname.toLocaleLowerCase()))
  }, [tabs, location]);

  return (
    <>
      { tab >= 0 && 
        <section style={{ backgroundColor: 'rgb(245,245,245)', borderBottom: '1px solid #ddd'}}>
          <Tabs value={tab}>
            { tabs.map(tab => 
                <Tab key={tab.title} 
                    label={tab.title} 
                    component={Link} 
                    to={tab.path} 
                    sx={{minWidth: 150}} />)
            }
          </Tabs>
        </section> 
      }
    </>
  );
}